import React, { useContext } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import DraftDispatchContext from "../../contexts/draftDispatchContext";
import DraftStateContext from "../../contexts/draftStateContext";
import { DRAFT_ACTIONS } from "./draftReducer";

export default function ControlledTabSection({ labels, panels }) {
  const draftState = useContext(DraftStateContext);
  const draftDispatch = useContext(DraftDispatchContext);

  return (
    <Tabs
      selectedIndex={draftState.selectedTab}
      onSelect={(index) => {
        draftDispatch({ type: DRAFT_ACTIONS.SELECT_TAB, payload: index });
      }}
      style={{ marginBottom: "1rem" }}
    >
      <TabList>
        {labels.map((label, i) => (
          <Tab key={i}>{label}</Tab>
        ))}
      </TabList>
      {panels.map((panel, i) => (
        <TabPanel key={i}>{panel}</TabPanel>
      ))}
    </Tabs>
  );
}
